export default {
      id: "icon-menu-usage",
      viewBox: "0 0 30 30",
      url: "/" + "sprite.svg#icon-menu",
      toString: function () {
        return this.url;
      }
    }